export const getZones = (state) => state.zones
export const getZoneIntervals = (state) => state.zone_intervals